var map = {
	"./arrow-green.png": "7a5e",
	"./article-1-.jpg": "8041",
	"./article-1.jpg": "9a65",
	"./article-2-.jpg": "de2b",
	"./article-2.jpg": "bdd5",
	"./article-3-.jpg": "6700",
	"./article-3.jpg": "b17a",
	"./blue-diamond.png": "b51e",
	"./brought-to-you-desktop-fr.png": "e4bc",
	"./brought-to-you-desktop.png": "18b9",
	"./brought-to-you-mobile-fr.png": "999f",
	"./brought-to-you-mobile.png": "562f",
	"./difference.jpg": "0e0b",
	"./email-icon.png": "7398",
	"./facebook-icon-white.svg": "fc8f",
	"./facebook-icon.svg": "0053",
	"./fb-share.jpg": "e43f",
	"./foods.svg": "a011",
	"./fruit-circled.svg": "7d7e",
	"./hampers.svg": "a311",
	"./hand-washing-is-the-first-defense.jpg": "380e",
	"./hands-family.svg": "dda2",
	"./heart-circled.svg": "3d15",
	"./heart-hands.svg": "1a39",
	"./hero-image-mobile.jpg": "77e2",
	"./hero-image.jpg": "e294",
	"./imagine-canada-logo.svg": "4ca6",
	"./impact-bg.png": "c8e4",
	"./instagram-icon-white.svg": "a61d",
	"./instagram-icon.svg": "b5a2",
	"./linkedin-icon-white.svg": "2069",
	"./linkedin-icon.svg": "d4a2",
	"./logo-white.svg": "e1d6",
	"./logo.svg": "1ae4",
	"./manulife-banner-icon.png": "915f",
	"./manulife-banner-logo-fr.svg": "ddd8",
	"./manulife-banner-logo.svg": "585d",
	"./manulife-bg.jpg": "a125",
	"./manulife-blue-text.png": "4c94",
	"./manulife-icon.png": "14f8",
	"./manulife-logo-big.png": "f175",
	"./manulife-logo-white-fr.png": "11e3",
	"./manulife-logo-white.png": "f53e",
	"./manulife-logo.png": "0af3",
	"./manulife-men-on-laptop..png": "9ccd",
	"./manulife-text.png": "d0a2",
	"./non-perishable.svg": "68d1",
	"./phone-icon.png": "503a",
	"./play.png": "d99c",
	"./post.jpg": "1d0a",
	"./savings-pig.svg": "e716",
	"./search-icon.svg": "3e7d",
	"./sharing-bg.png": "c6fe",
	"./staple-items-for-families-in-need.jpg": "30d3",
	"./tents-for-food-banks.jpg": "c831",
	"./tw-share.jpg": "d365",
	"./twitter-icon-white.svg": "0fdb",
	"./twitter-icon.svg": "e147",
	"./water-mark.png": "c517"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";